export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["फ़िल्टर"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्थिति"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्टोर"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खाता"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["लागू करें"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सब साफ़ करें"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्थिति चुनें"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्टोर चुनें"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["चालान संख्या दर्ज करें"])}
}